import { useQuery } from "@tanstack/react-query";
import { suggestionKeys, SuggestionsResponse } from "~/features/suggestions";

const HERE_ENDPOINT =
  "https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json?";

export function useSuggestions(
  query: string,
  location: string,
  country: string
) {
  const options = {
    query,
    country,
    apiKey: import.meta.env.VITE_HERE_API_KEY as string,
    prox: `${location},2500`,
  };

  const fetchSuggestions = (): Promise<SuggestionsResponse> =>
    fetch(HERE_ENDPOINT + new URLSearchParams(options)).then((response) =>
      response.json()
    );

  return useQuery(suggestionKeys.list(options), fetchSuggestions, {
    enabled: !!query.length,
  });
}
